<div
  *ngIf="ready && !visibility.isHidden && !card.isClickable"
  class="card"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
  [ngStyle]="{ 'background-color': background }"
>
  <app-content-repeater [items]="contents"></app-content-repeater>
</div>
<a
  *ngIf="
    ready && !visibility.isHidden && card.isClickable && card.url;
    else cardTemplate
  "
  class="card clickable"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
  [href]="card.url"
  target="_blank"
  rel="noopener noreferrer"
  (click)="onClick()"
  [ngStyle]="{ 'background-color': background }"
>
  <app-content-repeater [items]="contents"></app-content-repeater>
</a>
<ng-template #cardTemplate>
  <a
    *ngIf="ready && !visibility.isHidden && card.isClickable"
    class="card clickable"
    [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
    (click)="onClick()"
    [ngStyle]="{ 'background-color': background }"
  >
    <app-content-repeater [items]="contents"></app-content-repeater>
  </a>
</ng-template>
